export const selectIsFetchingTeam = ({ teams }) =>
  teams?.ui?.isFetchingTeam || false;
export const selectIsInvitingTeamMember = ({ teams }) =>
  teams?.ui?.isInvitingTeamMember || false;
export const selectIsUpdatingTeamMember = ({ teams }) =>
  teams?.ui?.isUpdatingTeamMember || false;
